import * as React from "react"

import Layout from "../components/Layout"

const InvestReasons = () => {
  return (
    <Layout>
      <h1>Why Invest AMO ? 5 Reasons</h1>

      <iframe
        title="Invest_Reasons"
        width="100%"
        height="600px"
        src="/5ReasonsCompiled.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default InvestReasons
